module.exports = __webpack_public_path__ + "static/img/14.88e7972.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/zh/14.png
// module id = /Rzs
// module chunks = 0